import FormattedMessage from 'I18n/components/FormattedMessage';
import { StaticContentWidget } from 'embedded-academy-lib';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { useState } from 'react';
import { useDetailsPageContext } from '../context/DetailsPageContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EmbeddedAcademyVideo({
  id,
  onTrackInteraction
}) {
  const {
    appContext
  } = useDetailsPageContext();
  const [videoName, setVideoName] = useState('');
  const [videoDescription, setVideoDescription] = useState('');
  const [videoLink, setVideoLink] = useState('');
  return /*#__PURE__*/_jsxs(Grid, {
    children: [/*#__PURE__*/_jsx(GridItem, {
      size: {
        sm: 12,
        md: 6
      },
      paddingBlockEnd: "200",
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        gap: "200",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "strong",
          children: videoName
        }), /*#__PURE__*/_jsx(Text, {
          children: videoDescription
        }), videoLink ? /*#__PURE__*/_jsx(Button, {
          onClick: () => onTrackInteraction === null || onTrackInteraction === void 0 ? void 0 : onTrackInteraction({
            action: 'click academy video link'
          }),
          use: "link",
          external: true,
          href: videoLink,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "detailsPage.functionalityCard.tabs.howItWorks.academyLink"
          })
        }) : null]
      })
    }), /*#__PURE__*/_jsx(GridItem, {
      size: {
        sm: 12,
        md: 6
      },
      paddingInlineStart: "0",
      paddingBlockEnd: "200",
      children: /*#__PURE__*/_jsx(StaticContentWidget, {
        authType: appContext === 'app' ? 'app' : 'public',
        shortId: id,
        language: "en",
        name: "Academy Static Content Widget Public",
        variant: "default",
        onContent: content => {
          // @ts-expect-error - contentDescription is not present in the StaticContent type but is present in the returned object
          const {
            contentName,
            contentDescription,
            sourceUrl
          } = content;
          setVideoName(contentName);
          setVideoDescription(contentDescription);
          setVideoLink(sourceUrl);
        }
      })
    })]
  });
}